import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Arquivos de tradução
import translationPT from "./locales/pt/translation.json";
import translationEN from "./locales/en/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    pt: { translation: translationPT },
    en: { translation: translationEN }
  },
  lng: "pt", // idioma padrão
  fallbackLng: "pt",
  interpolation: {
    escapeValue: false // React já faz escaping
  }
});

export default i18n;
